<script lang="ts">
    import { onMount } from "svelte";
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let types: any[] = [];
    let processingSeznam: boolean = false;

    onMount(() => {
        processingSeznam = true;

        dataProvider.type = "";
        dataProvider.searchString = "";
        dataProvider.order = "";
        dataProvider.orderDirection = "";

        dataProvider = dataProvider;
    });

    dataProvider.types.subscribe((data) => {
        types = data;

        if (data) {
            processingSeznam = false;
        }
    });

    setTimeout(() => {
        dataProvider.loadTypes();
    }, 10);

    function onSubmit(): void {
        dataProvider.type = "";
        dataProvider.searchString = "";
        dataProvider.order = "";
        dataProvider.orderDirection = "";

        serviceProvider.surveySearchService.sort();

        dataProvider = dataProvider;
    }

    function loadFilterSearch(): void {
        serviceProvider.surveySearchService.sort();

        dataProvider = dataProvider;
    }
</script>

{#if !processingSeznam}
    <form class="bno-hero-banner__form" aria-label="Vyhledávání anket">
        <div class="bno-form-control">
            <div class="bno-select">
                <select
                    name="oblast"
                    id="oblast"
                    bind:value={dataProvider.type}
                    on:change={loadFilterSearch}
                >
                    <option value="">Všechny ankety</option>
                    {#each types as type}
                        <option value={type.id}>{type.nazev}</option>
                    {/each}
                </select>
                <label class="bno-form-control__label u-sr-only" for="oblast">
                    Typ ankety
                </label>
            </div>
        </div>

        <div class="bno-search bno-search--compact">
            <div class="bno-search__inner">
                <div class="bno-form-control">
                    <input
                        type="text"
                        id="search"
                        name="search"
                        class="bno-form-control__input bno-form-control__input--standalone"
                        placeholder="Vyhledat"
                        bind:value={dataProvider.searchString}
                        on:keyup={loadFilterSearch}
                    />

                    <label
                        class="bno-form-control__label u-sr-only"
                        for="search"
                    >
                        Hledat
                    </label>
                </div>

                <button
                    class="bno-toggle bno-toggle--plain"
                    type="submit"
                    aria-label="Vyhledat"
                    on:click|preventDefault={onSubmit}
                >
                    <span class="bno-icon bno-icon--search" />
                </button>
            </div>
        </div>

        {#if dataProvider && (dataProvider.type || (dataProvider.searchString && dataProvider.searchString.trim()))}
            <button
                type="button"
                on:click|preventDefault={onSubmit}
                class="bno-button bno-button--secondary"
                >Zrušit&nbsp;filtr</button
            >
        {/if}
    </form>
{/if}
